import { createNativeStackNavigator } from '@react-navigation/native-stack'
import React, { useMemo } from 'react'

import { AccountPage } from 'pages/Account'
import { Chat } from 'pages/Chat'
import { FollowersMembersPage } from 'pages/FollowersMembers'
import { GroupSettingsPage } from 'pages/GroupSettings'
import { LeaderboardPage } from 'pages/Leaderboard'
import { MemberProfilePage } from 'pages/MemberProfile'
import { MembershipsPage } from 'pages/Memberships'
import { ShareUpspacePage } from 'pages/ShareUpspace'
import { UpspacePage } from 'pages/Upspace'

import { useCurrentUser } from 'hooks/useCurrentUser'
import { useUser } from 'hooks/useUser'

import { links } from 'utils/constants'

import { useFocusMode } from 'contexts/FocusModeContext'

const Stack = createNativeStackNavigator()

export const UpspaceStack = () => {
  const focusMode = useFocusMode()
  const isFocusMode = useMemo(() => focusMode.group !== undefined, [focusMode.group])

  const { data: currentUser } = useCurrentUser()
  const { data: user } = useUser({ userId: focusMode.group?.trainer.id })

  return (
    <Stack.Navigator>
      <Stack.Screen
        component={UpspacePage}
        name={links.GROUP_PAGE}
        options={{
          title: 'Group',
          headerShown: false,
        }}
        initialParams={{ username: isFocusMode ? user?.username : currentUser?.username }}
      />
      <Stack.Screen
        name={links.SHARE_GROUP_PAGE}
        component={ShareUpspacePage}
        options={{ title: 'Share a Group', headerShown: false }}
      />
      <Stack.Screen
        component={FollowersMembersPage}
        name={links.FOLLOWERS_MEMBERS_PAGE}
        options={{
          headerShown: false,
        }}
      />
      <Stack.Screen
        component={MemberProfilePage}
        name={links.MEMBER_PROFILE_PAGE}
        options={{
          title: 'Member Profile',
          headerShown: false,
        }}
      />
      <Stack.Screen
        name={links.CHAT_PAGE}
        component={Chat}
        options={{
          title: 'Conversations',
          headerShown: false,
        }}
      />
      <Stack.Screen
        name={links.ACCOUNT_PAGE}
        component={AccountPage}
        options={{
          headerShown: false,
        }}
      />
      <Stack.Screen
        component={GroupSettingsPage}
        name={links.GROUP_SETTINGS_PAGE}
        options={{
          headerShown: false,
        }}
      />
      <Stack.Screen
        component={LeaderboardPage}
        name={links.LEADERBOARD_PAGE}
        options={{
          title: 'Leaderboard',
          headerShown: false,
        }}
      />
      <Stack.Screen
        name={links.MEMBERSHIPS_PAGE}
        component={MembershipsPage}
        options={{
          headerShown: false,
        }}
      />
    </Stack.Navigator>
  )
}
